import Splide from '@splidejs/splide';

const ContentLinkBlocks = () => {
    const sections = document.querySelectorAll('.block-card-grid.mobile-slider');

    for (const section of sections) {
        const splideElement = section.querySelector('.splide');
        if ( !splideElement ) continue;

        new Splide( splideElement, {
            perPage: 1,
            gap: '1rem',
            mediaQuery: 'min',
            pagination: false,
            breakpoints: {
                768: {
                    destroy: true,
                },
            },
        } ).mount( {} );
    }
}

export default ContentLinkBlocks;